/**
 * LOGGED USER
 */
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const USER_LOADING_FAILED = "USER_LOADING_FAILED";
export const USER_LOGOUT = "USER_LOGOUT";
export const SET_USERNAME = "SET_USERNAME";
export const USER_ROLES_EVALUATED = "USER_ROLES_EVALUATED";
export const SET_USERS_PHOTOS = "SET_USERS_PHOTOS";

/**
 * INITIAL LOADING
 */
export const INITIAL_LOADING = "INITIAL_LOADING";
export const INITIAL_LOADING_DONE = "INITIAL_LOADING_DONE";
export const INITIAL_LOADING_FAILED = "INITIAL_LOADING_FAILED";

/**
 * CLIENT
 */
export const CLIENT_LOADED = "CLIENT_LOADED";
export const CLIENT_LOADING_FAILED = "CLIENT_LOADING_FAILED";
export const CLIENT_LOADING = "CLIENT_LOADING";
export const CLIENT_DETAIL_OPEN = "CLIENT_DETAIL_OPEN";
export const SET_CLUID = "SET_CLUID";

/**
 * COMPANY
 */
export const COMPANY_LOADED = "COMPANY_LOADED";
export const COMPANY_LOADING_FAILED = "COMPANY_LOADING_FAILED";
export const COMPANY_LOADING = "COMPANY_LOADING";

/**
 * DOCUMENTS
 *
 */


export const DOCUMENT_UPLOADING_ERR = "DOCUMENT_UPLOADING_ERR";
export const DOCUMENT_UPLOADING = "DOCUMENT_UPLOADING";

/**
 * THREAD
 */
export const SET_THREAD = "SET_THREAD";
export const THREAD_LOADING = "THREAD_LOADING";
export const THREAD_LOADING_FAILED = "THREAD_LOADING_FAILED";
export const SET_FUTURE_THREAD_SUBJECT = "SET_FUTURE_THREAD_SUBJECT";
export const SET_THREAD_HISTORY = "SET_THREAD_HISTORY";
export const THREAD_HISTORY_LOADING = "THREAD_HISTORY_LOADING";
export const THREAD_HISTORY_LOADING_FAILED = "THREAD_HISTORY_LOADING_FAILED";

export const SET_NEW_NOTE = "SET_NEW_NOTE";
export const NEW_NOTE_LOADING = "NEW_NOTE_LOADING";
export const NEW_NOTE_LOADING_FAILED = "NEW_NOTE_LOADING_FAILED";

/**
 * CASE
 */
export const SET_CIDLA = "SET_CIDLA";
export const PARAM_CIDLA = "cidla";


/**
 * MESSAGE_COUNT
 */
export const SET_MESSAGE_COUNT = "SET_MESSAGE_COUNT";
export const SET_ADD_MESSAGE = "SET_ADD_MESSAGE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const MESSAGE_UPLOADED = "MESSAGE_UPLOADED";
export const MESSAGE_UPLOADING = "MESSAGE_UPLOADING";
export const MESSAGE_UPLOAD_FAIL = "MESSAGE_UPLOAD_FAIL";
export const ATTACHMENT_UPLOADED = "ATTACHMENT_UPLOADED";
export const ATTACHMENT_UPLOADING = "ATTACHMENT_UPLOADING";
export const ATTACHMENT_UPLOAD_FAIL = "ATTACHMENT_UPLOAD_FAIL";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const ATTACHMENT_ADDED = "ATTACHMENT_ADDED";
export const MAX_MESSAGE_LENGTH = 2000;

/**
 * ACTION_TYPES
 */
export const NOTE_ACTION_TYPE = "NOTE";

/**
 * ALERT
 */
export const ALERT_HIDE = "ALERT_HIDE";
export const ALERT_SHOW = "ALERT_SHOW";
export const ALERT_FLOATING_CLOSE_DURATION = 10000;
export const ALERT_SUCCESS = "success";
export const ALERT_WARNING = "warning";
export const ALERT_DANGER = "danger";
export const ALERT_INFO = "info";

/**
 * ERROR
 */
export const BLOCK_SCREEN_WITH_MESSAGE = "BLOCK_SCREEN_WITH_MESSAGE";

/**
 *
 * @type {string}
 */
export const COLOR_PRIMARY = "primary";
export const COLOR_SECONDARY = "secondary";
export const COLOR_SUCCESS = "success";
export const COLOR_WARNING = "warning";
export const COLOR_INFO = "info";

export const ICON_WARNING = "warning";
export const ICON_DANGER = "comment-important";
export const ICON_SUCCESS = "checkmark-circle";
export const ICON_INFO = "info";

/**
 * FILES
 */
export const FILE_SOURCE_ESPIS = "FILE_SOURCE_ESPIS";
export const FILE_SOURCE_LOCAL = "FILE_SOURCE_LOCAL";

/**
 * AUTH
 */
export const ADFS_AUTH_FAILED = "ADFS_AUTH_FAILED";
export const ADFS_ACCESS_EXPIRING = "ADFS_ACCESS_EXPIRING";
export const ADFS_ACCESS_EXPIRING_NOTED = "ADFS_ACCESS_EXPIRING_NOTED";
export const AUTH_INFO_LOADED = "AUTH_INFO_LOADED";
export const AUTH_INFO_FAILED = "AUTH_INFO_FAILED";
export const AUTH_INFO_LOADING = "AUTH_INFO_LOADING";
export const AUTH_INFO_INVALIDATE = "AUTH_INFO_INVALIDATE";
export const AUTH_REFRESHING = "AUTH_REFRESHING";
export const AUTH_REFRESHED = "AUTH_REFRESHED";
export const AUTH_REFRESH_FAILED = "AUTH_REFRESH_FAILED";
export const PARAM_STATE = "state";


/**
 * HumanTask
 */
export const HUMAN_TASK_LOADING = "HUMAN_TASK_LOADING";
export const HUMAN_TASK_LOADED = "HUMAN_TASK_LOADED";
export const HUMAN_TASK_LOADING_FAILED = "HUMAN_TASK_LOADING_FAILED";
export const UPDATE_HUMAN_TASK = "UPDATE_HUMAN_TASK";
export const ACTUAL_OWNER_FULLNAME = "ACTUAL_OWNER_FULLNAME";

export const HUMAN_TASK_ACTION = "HUMAN_TASK_ACTION";

/**
 * CaseType
 */
export const SCMIT = "SCMIT";
export const KYC_MIT = "CT1724_MIT";
export const COL_MIT = "CT1609_MIT";
export const FHC_MIT = "CT1782_MIT";
export const SCMITGBIZ = "SCMITGBIZ";
export const SCPULSEMITGBIZ = "SCPULSEMITGBIZ";

/**
 * Layout
 **/
export const LAYOUT_UPDATE = "LAYOUT_LOADED";
export const MENU_TOGGLED = "MENU_TOGGLED";
export const NOTES_TOGGLED = "NOTES_TOGGLED";
export const CANCEL_MODAL_TOGGLE = "CANCEL_MODAL_TOGGLE";
export const APP_SECTION_HEADER = 'applicationHeader';
export const APP_SECTION_SUBHEADER = 'applicationSubheader';
export const APP_SECTION_CONTENT = 'applicationContent';
export const APP_SECTION_MESSAGE_CREATOR = 'applicationMessageCreator';
export const APP_TOTAL_HEIGHT = 'applicationHeight';
export const APP_SECTION_NOTE_BUTTONS = 'applicationNoteButtons';
export const APP_SECTION_ADD_NOTE_BUTTON = 'applicationAddNoteButton';
export const APP_SECTION_UPDATE_NOTE_BUTTON = 'applicationUpdateNoteButton';

/**
 * Menu
 */
export const DEFAULT_MAX_NOTE_HEIGHT = 500;
export const DEFAULT_NOTE_BODY_HEIGHT = 750;

/**
 * Task statuses
 */
export const CREATED = {key: 'CREATED', label: 'Vytvořený'};
export const READY = {key: 'READY', label: 'Připravený'};
export const RESERVED = {key: 'RESERVED', label: 'Rezervovaný'};
export const IN_PROGRESS = {key: 'IN_PROGRESS', label: 'Probíhající'};
export const SUSPENDED = {key: 'SUSPENDED', label: 'Přerušený'};
export const COMPLETED = {key: 'COMPLETED', label: 'Dokončený'};
export const EXITED = {key: 'EXITED', label: 'Zrušený'};
export const FAILED = {key: 'FAILED', label: 'Chybující'};
export const ERROR = {key: 'ERROR', label: 'Chybující'};

export const ACTIVE_STATES = [CREATED, READY, RESERVED, IN_PROGRESS, SUSPENDED];
export const TAKE_READY_STATES = [CREATED, READY, RESERVED];
export const FINAL_STATES = [COMPLETED, EXITED, FAILED, ERROR];

/**
 * FILES
 * - mimetypes for smartDropzone component - it prefilters only documents of desired types
 * - extensions for SmartDropzone component - additional filtering for chosen documents. For some reason *.csv is considered as xls/xlsx document that is valid
 */
export const ACCEPTED_EXTENSIONS = ['.doc', '.docx', '.txt', 'xls', 'xlsx', '.xlsm', '.ppt', '.pptx', '.pdf', '.jpg', '.jpeg', '.gif', '.png', '.tiff', '.tif', '.kpc', '.cfd', '.cfa', '.heic', '.csv', '.gpc', '.sta', '.xml', '.zip'];
export const ACCEPTED_MIMETYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'image/jpeg',
    'image/gif',
    'image/png',
    'image/tiff',
    'application/zip',
    'application/x-zip-compressed',
    'image/heic',
    /* This empty string value is here for unknown formats of files in frontend - .kcp, .cfd, .cfa - https://csas.atlassian.net/browse/CSO-229605 */
    '',
    'text/csv',
    'text/xml',
    'application/xml'
];

/**
 * Environment
 */
export const ENVIRONMENT_PROPERTIES_ERROR = "ENVIRONMENT_PROPERTIES_ERROR";
export const ENVIRONMENT_PROPERTIES_LOADED = "ENVIRONMENT_PROPERTIES_LOADED";
export const ENVIRONMENT_PROPERTIES_LOADING = "ENVIRONMENT_PROPERTIES_LOADING";

/**
 *  Module
 */
export const MIT_GBIZ = "mit-gbiz";